// src/App.js
import InvoiceValidationInterface from './components/InvoiceValidationInterface';
import './App.css';

function App() {
  return (
    <div className="App">
      <InvoiceValidationInterface />
    </div>
  );
}

export default App;